// Every localStorage key (values are JSON, read through lib/storage `store`).

export const STORAGE = {
  /** laptop shell: the navigation rail shows labels (per device) */
  railExpanded: 'shell.rail.expanded',
  /** overview: the right-hand panel is collapsed so the map shows in full */
  overviewSideCollapsed: 'overview.side.collapsed',
  /** overview: the "Alur distribusi" panel is folded into its rail (per viewer; absent = decided by the width) */
  overviewFlowCollapsed: 'overview.flow.collapsed',
  /** overview: the camera follows live events */
  overviewFollow: 'overview.follow',
  /** the overview map's Lapisan: which layers are drawn */
  overviewLayers: 'overview.layers',
  /** the overview map's national "Tampilan": 'cluster' or 'province' (one bubble per province with its emblem) */
  overviewGrouping: 'overview.grouping',
  /** maps with a basemap switch: 'map' or 'satellite' */
  mapBasemap: 'map.basemap',
  /** a short tone for new critical alerts (off by default, per device) */
  alertSound: 'alerts.sound',
  /** overview: monitor (kiosk) mode for a control-room screen */
  overviewMonitor: 'overview.monitor',
  /** overview map: the region (kota/kabupaten) shown */
  overviewRegion: 'overview.region',
  /** operator register: tipe and dates remembered for the next cylinder */
  registerPrefs: 'op.register.prefs',
  /** Surat Jalan print: the paper last chosen on this device ('a5' or 'form') */
  shipmentPaper: 'shipments.print.paper',
} as const;

/** sessionStorage keys (values are JSON, read through lib/storage `sessionStore`). */
export const SESSION_STORAGE = {
  /** Kirim Tabung, a Penarikan loading: the cylinder ids whose reason the operator confirmed (ids only, no PII) */
  dispatchReasons: (shipmentId: number) => `op.dispatch.reasons.${shipmentId}`,
  /**
   * A field verifier's unsent visit report, so a tab the camera pushed out of memory comes back with it: the answers,
   * notes, the device position and the photos' upload ids only, never the applicant's personal data. Cleared once sent.
   */
  visitDraft: (visitId: number) => `hub.visit.draft.${visitId}`,
  /**
   * A courier's unsent exchange at a house: the serials scanned, the condition, the cash typed, the device position,
   * the photo's upload id and the idempotency token only, never the citizen's personal data nor the confirmation code.
   * Cleared once sent.
   */
  deliveryDraft: (orderId: number) => `courier.delivery.draft.${orderId}`,
  /** the full cylinder a courier scanned at the Hub while the line was down (its serial only), until the server has it */
  deliveryOut: (orderId: number) => `courier.delivery.out.${orderId}`,
  /** the Hub's in-person check of a household: the two "seen" ticks and the KK photo's upload id only (no personal data) */
  verifyDraft: (householdId: number) => `hub.household.verify.${householdId}`,
  /** the Hub counter's unsent pickup exchange: as the courier's draft, without the code */
  pickupDraft: (orderId: number) => `hub.pickup.draft.${orderId}`,
} as const;

/** Keys older versions wrote and nothing reads any more; removed on sign-in. */
export const RETIRED_STORAGE = [
  /** the location an admin or roaming operator picked (since 1 account = 1 location there is no picking) */
  'op.location',
] as const;

/** sessionStorage: a stale chunk already triggered one reload in this tab (no reload loop). */
export const CHUNK_RELOAD_KEY = 'app.chunk-reload';
